import { Col, Row } from "reactstrap"
import { OpportunityOutcomeType, OutcomeResult } from "models/opportunity-dashboard"
import StageSummaryTable from "./stage-summary-table"
import OpportunityListTable from "./opportunity-list-table"
import GroupBarChart from "./group-bar-chart"
import GroupTreemapChart from "./group-treemap-chart"
import { money, percent } from "./format"

interface OutcomeReportTabProps {
    type: OpportunityOutcomeType
    data: OutcomeResult
}

const OUTCOME: Record<OpportunityOutcomeType, { label: string; tone: string; short: string }> = {
    canceled: { label: "Process Cancelled", tone: "text-warning", short: "Canceled" },
    lost: { label: "Process Lost", tone: "text-danger", short: "Lost" },
    won: { label: "Process Won", tone: "text-primary", short: "Won" },
}

// Process Canceled / Lost / Won report: counts and ratio, the stage, the result by division,
// the opportunities with that result, and the result by department.
const OutcomeReportTab = ({ type, data }: OutcomeReportTabProps) => {
    const outcome = OUTCOME[type]

    return <div className="d-flex flex-column gap-4">
        <Row className="g-4">
            <Col xl={7}>
                <div className="d-flex flex-column gap-4">
                    <div className="outcome-kpis">
                        <div title={money(data.totalValue)}>
                            <span>Total:</span> <strong className="text-success">{data.totalCount}</strong>
                        </div>
                        <div title={money(data.outcomeValue)}>
                            <span>{outcome.label}:</span> <strong className={outcome.tone}>{data.outcomeCount}</strong>
                        </div>
                        <div title={`${percent(data.valueRatio)} of total value`}>
                            <span>Current Ratio:</span> <strong className={outcome.tone}>{percent(data.countRatio, 2)}</strong>
                        </div>
                    </div>
                    <div>
                        <h5>Stage</h5>
                        <StageSummaryTable rows={data.stages} />
                    </div>
                </div>
            </Col>
            <Col xl={5}>
                <GroupBarChart title={`${outcome.short} by Division`} data={data.byDivision} />
            </Col>
        </Row>
        <div>
            <h5>Opportunities</h5>
            <OpportunityListTable rows={data.rows} />
        </div>
        <GroupTreemapChart title={`${outcome.short} by Department`} data={data.byDepartment} />
    </div>
}

export default OutcomeReportTab
